export default "__VITE_ASSET__aU6n4GYX__"